import React, { useState, useEffect } from "react";
import axios from "axios";
import { BASE_URL } from "../../../constants";
import { Container, Card, Row, Col, Button, InputGroup } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import Select from 'react-select';
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Mthly_Fee_Register = () => {

  const [selectedStd, setSelectedStd] = useState();
  const [ddlStds, setDdlStds] = useState([]);
  const [selectedDiv, setSelectedDiv] = useState();
  const [ddlDivisions, setDdlDivisions] = useState([]);

  const [selectedYear1, setSelectedYear1] = useState();
  const [ddlAcademicYears, setDdlAcademicYears] = useState([]);

  const [reportData, setReportData] = useState([]);

  useEffect(() => {

    loadDropdowns();

  }, []);

  const loadDropdowns = async () => {
    try {

      const std = await axios.get(`${BASE_URL}/api/ddl_all_standards`);
      setDdlStds(std.data);

      const year_result = await axios.get(`${BASE_URL}/api/ddl_years`);
      setDdlAcademicYears(year_result.data);


    } catch (err) {
      console.error(err);
    }

  };

  /// To Populate Division on change of Standard
  useEffect(() => {

    const fetchDivision = async () => {
      try {
        setDdlDivisions([]);
        if (selectedStd) {
          const res = await axios.get(`${BASE_URL}/api/ddl_division`, { params: { p_Std_Id: selectedStd } });
          setDdlDivisions(res.data || []);
        }
      } catch (error) {
        console.error("Error fetching Division:", error);
      }
    };

    fetchDivision();

  }, [selectedStd]);

  const selectedStdName = ddlStds.find(std => std.std_id === Number(selectedStd))?.std_name || "";
  const selectedDivName = ddlDivisions.find(div => div.div_id === Number(selectedDiv))?.div_name || "";

  // Fetch report
  const handleRunReport = async () => {

    if (!selectedStd || selectedStd === '') {
      toast.error("Please select Standard.");
      return;      
    } else if (!selectedDiv || selectedDiv === '') {
      toast.error("Please select Division.");
      return;      
    } else if (!selectedYear1 || selectedYear1 === '') {
      toast.error("Please select Academic Year.");
      return;      
    }

    try {

      setReportData([]);

      const res = await axios.get(`${BASE_URL}/api/rpt_monthly_fee_register`, {
        params: {
          p_std_id: selectedStd,
          p_div_id: selectedDiv,
          p_year1: selectedYear1
        }
      });

      if (res.data.length > 0) {
        setReportData(res.data);
      } else {
        setReportData([]);
        toast.error("No Records Found");
      }

    } catch (err) {
      console.error("Report Error:", err);
      toast.error("Error loading Report.");
    }

  };

  const formatDate = (dateStr) => {
    const date = new Date(dateStr);

    const day = String(date.getDate()).padStart(2, "0");
    const month = date.toLocaleString("en-US", { month: "short" }); // Jan, Feb, etc.
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
  };

  const formatDateForFile = (dateStr) => {
    const [year, month, day] = dateStr.split("-"); // safest approach
    return `${day}-${month}-${year}`;
  };

  ///// Start : PDF Download
  const handleDownloadPDF = () => {

    if (reportData.length === 0) {
      alert("No data to download");
      return;
    }

//    const doc = new jsPDF("landscape");
    const doc = new jsPDF("landscape", "mm", "a4");

    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();

    const now = new Date();
    const timestamp = now.toLocaleString();

    // ================= HEADER =================
    doc.setFont("helvetica", "bold");
    doc.setFontSize(16);
    doc.setTextColor(0, 102, 204);
    doc.text("St. Haris High School", pageWidth / 2, 15, { align: "center" });

    doc.setFontSize(12);
    doc.setTextColor(0, 0, 0);
    doc.text(`Monthly Fee Register for ${selectedStdName} / ${selectedDivName} - ${selectedYear1}-${Number(selectedYear1) + 1} `, 
                   pageWidth / 2, 22, { align: "center" });

    // doc.setFontSize(10);
    // doc.setTextColor(100);
    // doc.text(`From: ${formatDate(fromDate)}  To: ${formatDate(toDate)}`, pageWidth / 2, 28,{ align: "center" });

    doc.setDrawColor(200);
    doc.line(14, 30, pageWidth - 14, 30);

    // ================= TABLE =================

    const tableColumn = [
      "GR No.",
      "Student Name",
      "Installment-1",
      "Installment-2",
      "Installment-3",
      "Installment-4",
      "Installment-5",
      "Installment-6"
    ];

    const tableRows = reportData.map((n, idx) => [
      //idx + 1,
      n.gr_no || "",
      n.stud_name || "",
      n.install_1 || "",
      n.install_2 || "",
      n.install_3 || "",
      n.install_4 || "",
      n.install_5 || "",
      n.install_6 || ""
    ]);

    autoTable(doc, {
      head: [tableColumn],
      body: tableRows,
      startY: 36,

      styles: {
        fontSize: 7,
        cellPadding: 2,
        overflow: "linebreak" // ✅ wraps text like your React table
      },

      headStyles: {
        fillColor: [0, 102, 204],
        textColor: 255,
        fontStyle: "bold",
        //halign: "center"
      },

      columnStyles: {
        // 0: { halign: "center", cellWidth: 10 },
        0: { cellWidth: 20 },
        1: { halign: "left", cellWidth: 70 },
        2: { halign: "center", cellWidth: 30 },
        3: { halign: "center", cellWidth: 30 },
        4: { halign: "center", cellWidth: 30 }, 
        5: { halign: "center", cellWidth: 30 }, 
        6: { halign: "center", cellWidth: 30 },
        7: { halign: "center", cellWidth: 30 },
        // 8: { cellWidth: 45 }
      },

      didParseCell: function (data) {
        if (data.section === "head") {
          data.cell.styles.halign =
            data.column.index === 1 ? "left" : "center";
        }
      },

      didDrawPage: function () {
        const pageNumber = doc.getNumberOfPages();

        doc.setFontSize(9);
        doc.setTextColor(150);

        doc.setDrawColor(200);
        doc.line(14, pageHeight - 15, pageWidth - 14, pageHeight - 15);

        doc.text("eSchool", 14, pageHeight - 10);

        doc.text(
          `Generated on: ${timestamp}`,
          pageWidth / 2,
          pageHeight - 10,
          { align: "center" }
        );

        doc.text(
          `Page ${pageNumber}`,
          pageWidth - 14,
          pageHeight - 10,
          { align: "right" }
        );
      }
    });

    doc.save(
      `Monthly_Fee_Register_${selectedStdName}-${selectedDivName}_${selectedYear1}-${Number(selectedYear1) + 1}.pdf`
    );

  };

  return (

    <Container fluid className="p-3">

      {/* Filters */}
      <Card className="p-3 mb-3">
        <Row>

          <Col md={3}>
            <InputGroup>
              <InputGroup.Text style={{ width: "120px" }}> Standard
              </InputGroup.Text>
              <select className="form-select"
                      name="selectedStd" value={selectedStd} onChange={(e) => setSelectedStd(e.target.value)} >
                <option value="">--Select Standard--</option>
                {ddlStds.map(std => (
                  <option key={std.std_id} value={std.std_id}>{std.std_name}</option>
                ))}
              </select>
            </InputGroup>
          </Col>

          <Col md={2}>
            <InputGroup>
              <InputGroup.Text style={{ width: "90px" }}>Division
              </InputGroup.Text>
              <select className="form-select" name="selectedDiv"
                value={selectedDiv} onChange={(e) => setSelectedDiv(e.target.value)} >
                <option value="">-- Select Division --</option>
                <option value="0">All Divisions</option>
                {ddlDivisions.map(div => (
                  <option key={div.div_id} value={div.div_id}>{div.div_name}</option>
                ))}
              </select>
            </InputGroup>

          </Col>

          <Col md={3}>
            <InputGroup>
              <InputGroup.Text style={{ width: "135px" }}>Academic Year 
              </InputGroup.Text>
              <select className="form-select" name="selectedYear1" value={selectedYear1}
                onChange={(e) => setSelectedYear1(e.target.value)} >
                <option value="">--Select Acadamic Year--</option>
                {ddlAcademicYears.map(y => (
                  <option key={y.year1} value={y.year1}>{y.disp_year}</option>
                ))}
              </select>
            </InputGroup>
          </Col>

          <Col md={4} className="d-flex justify-content-end">
            <Button variant="primary" className="ms-2"
              disabled={reportData.length === 0} onClick={handleDownloadPDF} > Download PDF
            </Button>
            {/* <Button variant="success" className="ms-2"
              onClick={handleDownloadExcel}
              disabled={reportData.length === 0}> Download Excel
            </Button> */}
            <Button variant="success" onClick={handleRunReport} className="ms-2">
              Run Report
            </Button>          
          </Col>
        </Row>

      </Card>

      {/* Report Table */}
      <Card className="p-3">
        <div style={{ minHeight: '220px' }} className="table-responsive">
          <table style={{ maxHeight: '35px' }} className="responsive-table scty-custom-table-rcpt hover-table-rcpt">
            <thead className="table-light">
              <tr>
                {/* <th style={{ textAlign: 'center', width: '3%' }}>#</th> */}
                {/* <th>Notice Type</th> */}
                <th style={{ textAlign: 'left', width: '9%' }} >GR No. </th>
                <th style={{ textAlign: 'left', width: '30%' }} >Student Name </th>
                <th style={{ textAlign: 'center', width: '8%' }} >Installment-1</th>
                <th style={{ textAlign: 'center', width: '8%' }} >Installment-2</th>
                <th style={{ textAlign: 'center', width: '8%' }} >Installment-3</th>
                <th style={{ textAlign: 'center', width: '8%' }} >Installment-4</th>
                <th style={{ textAlign: 'center', width: '8%' }} >Installment-5</th>
                <th style={{ textAlign: 'center', width: '8%' }} >Installment-6</th>
              </tr>
            </thead>

            <tbody>
              {reportData.length > 0 ? (
                reportData.map((n, idx) => (
                  <tr key={n.irn}>
                    {/* <td style={{ textAlign: 'center' }} >{idx + 1}</td> */}
                    <td style={{ textAlign: 'left' }}> {n.gr_no} </td>
                    <td style={{ textAlign: 'left' }} >{n.stud_name}</td>
                    <td style={{ textAlign: 'center' }}> {n.install_1} </td>
                    <td style={{ textAlign: 'center' }}> {n.install_2} </td>
                    <td style={{ textAlign: 'center' }}> {n.install_3} </td>
                    <td style={{ textAlign: 'center' }}> {n.install_4} </td>
                    <td style={{ textAlign: 'center' }}> {n.install_5} </td>
                    <td style={{ textAlign: 'center' }}> {n.install_6} </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="8" className="text-center">
                    No Entry found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </Card>

    </Container>
  );
};

export default Mthly_Fee_Register;
